import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 32, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, gold = true }) {
  return (
    <p className={`text-[10px] md:text-xs uppercase tracking-[0.35em] font-semibold ${gold ? "text-gold" : "text-rose"}`}>
      {children}
    </p>
  );
}
